import Vue from "vue";
import Router from "vue-router";

import HelloWorld from "@/components/HelloWorld";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "HelloWorld",
      redirect: "/homes",
      component: HelloWorld,
      children: [
        {
          path: "/homes",
          name: "homes",
          component: (resolve) =>
            require(["@/components/nav/homeItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/journal",
          name: "journal",
          component: (resolve) =>
            require(["@/components/nav/journalItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/aboutus",
          name: "aboutus",
          component: (resolve) =>
            require(["@/components/nav/aboutusItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/newsItem",
          name: "newsItem",
          component: (resolve) =>
            require(["@/components/nav/newsItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/chineseItem",
          name: "chineseItem",
          component: (resolve) =>
            require(["@/components/nav/chineseItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/manuscript",
          name: "manuscript",
          component: (resolve) =>
            require(["@/components/nav/manuscript"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/PdfReader",
          name: "PdfReader",
          component: (resolve) => require(["@/components/nav/pdf"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/bookInfo",
          name: "bookInfo",
          component: (resolve) =>
            require(["@/components/nav/bookInfo"], resolve),
        },
        {
          path: "/contactItem",
          name: "contactItem",
          component: (resolve) =>
            require(["@/components/nav/contactItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/searchItem",
          name: "searchItem",
          component: (resolve) =>
            require(["@/components/nav/searchItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/pdfItem",
          name: "pdfItem",
          component: (resolve) =>
            require(["@/components/nav/pdfItem"], resolve),
          meta: {
            keepAlive: true,
            isBack: false,
          },
        },
        {
          path: "/newsInfo",
          name: "newsInfo",
          component: (resolve) =>
            require(["@/components/nav/newsInfo"], resolve),
        },
      ],
    },
    // // vue异步组件
    {
      path: "/404",
      name: "404",
      component: (resolve) => require(["@/components/nav/NoView"], resolve),
    },
  ],
});
